import config from 'config'

export const TERMS_LINK = `${config.credibleRoot}/terms`
export const PRIVACY_LINK = `${config.credibleRoot}/privacy`
